import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import RateTable from '../rate-table/rate-table';
import { SectionContainer } from './styles';
import type { RateTableForm } from './types';

interface RateTableElementProps {
  form: RateTableForm;
}

const RateTableElement = ({ form }: RateTableElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <RateTable />
    </FormProvider>
  </SectionContainer>
);

export default memo(RateTableElement);
